import type { ColumnOption } from "interfaces/columnOptions";
import { TemplateImage } from "components/people/templates/TemplateImage";
import { Title } from "components/listViewTemplates";
import { Tooltip } from "components/common/tooltip";
import { TextTruncate } from "components";
import dateTimeUtils from "utils/dateTimeUtils";
import { TemplatesOverviewColumns } from "features/People/GroupTemplate/Overview/columnOptions";
import { type TemplateOverview } from "features/Library/PeopleAssignments/Overview/types";

export const getReadonlyColumnOptions = (): ColumnOption<TemplateOverview>[] => {
  return [
    {
      name: TemplatesOverviewColumns.Name,
      width: 1,
      isSortable: true,
      render: () => {
        return <TemplateImage imageUrl={""} />;
      },
    },
    {
      name: "",
      width: 5,
      isSortable: false,
      render: (item) => <Title title={item.name} clamp={2} className="normal-color" />,
    },
    {
      name: TemplatesOverviewColumns.Owner,
      width: 3,
      isSortable: false,
      render: (item) => <Tooltip target={<TextTruncate>{item.publisher}</TextTruncate>} content={item.publisher} />,
    },
    {
      name: TemplatesOverviewColumns.Added,
      width: 3,
      isSortable: true,
      render: (item) => dateTimeUtils.formatDate(item.dateCreated),
    },
    {
      name: TemplatesOverviewColumns.Modified,
      width: 3,
      isSortable: true,
      render: (item) => dateTimeUtils.formatDate(item.dateModified),
    },
  ];
};
